import bolt_logo from "../../assets/logo/small-logo.svg";
import bolt_logo_sub from "../../assets/logo/logo.png";
import icon_logo from "../../assets/logo/logo-nocompanyname.png";
import bgLogin from "../../assets/images/bg-login.png";
import icon_logo_login from "../../assets/logo/main-logo.png";
import icon_filter from "../../assets/images/filter.svg";
import icon_default_image from "../../assets/images/default-image.svg";
import icon_history from "../../assets/images/history.svg";
import icon_rhb_payment from "../../assets/images/RHB.svg";

//menu
import { ReactComponent as icon_dashboard } from "../../assets/images/sidebar/dashboard.svg";
import { ReactComponent as icon_payroll } from "../../assets/images/sidebar/payroll.svg";
import { ReactComponent as icon_user } from "../../assets/images/sidebar/user.svg";
import { ReactComponent as icon_billing } from "../../assets/images/sidebar/billing.svg";
import { ReactComponent as icon_profile } from "../../assets/images/sidebar/profile.svg";
import { ReactComponent as icon_logout } from "../../assets/images/sidebar/logout.svg";
import { ReactComponent as icon_company } from "../../assets/images/sidebar/company.svg";
import icon_excel from "../../assets/images/sidebar/excel.svg";
import icon_add from "../../assets/images/sidebar/add.svg";
import icon_add_white from "../../assets/images/sidebar/add-white.svg";

// country
import icon_malaysia from "../../assets/images/malaysia.png";

// modal icon
import icon_update_status from "../../assets/images/modal-icon/status-update.svg";
import icon_mark_as_disbursed from "../../assets/images/modal-icon/disbursed.svg";
import icon_mark_as_cancel_payroll from "../../assets/images/modal-icon/cancel.svg";
import icon_revert_for_processing_payroll from "../../assets/images/modal-icon/revert-for-processing.svg";
import icon_comment from "../../assets/images/comment.svg";
import icon_receipt from "../../assets/images/receipt-icon.svg";
import icon_attch_excel from "../../assets/images/excel-attch-icon.svg";
import icon_pdf from "../../assets/images/pdf-icon.svg";
import icon_modal_billing from "../../assets/images/modal-icon/billing.png";
import icon_modal_payroll from "../../assets/images/modal-icon/payroll.png";
import icon_warning from "../../assets/images/modal-icon/warning.svg";
import icon_whatsapp from "../../assets/images/modal-icon/whatasapp.svg";
import icon_modal_company_active from "../../assets/images/modal-icon/company-active.svg";
import icon_modal_company_suspended from "../../assets/images/modal-icon/company-suspended.svg";
import icon_modal_company_terminated from "../../assets/images/modal-icon/company-terminated.svg";

//bank
import icon_bank_affin from "../../assets/images/bank/affin.png";
import icon_bank_agro from "../../assets/images/bank/agro.png";
import icon_bank_alliance from "../../assets/images/bank/alliance.png";
import icon_bank_alrajhi from "../../assets/images/bank/alrajhi.png";
import icon_bank_ambank from "../../assets/images/bank/ambank.png";
import icon_bank_america from "../../assets/images/bank/america.png";
import icon_bank_bsn from "../../assets/images/bank/bsn.png";
import icon_bank_chartered from "../../assets/images/bank/chartered.png";
import icon_bank_chase from "../../assets/images/bank/chase.png";
import icon_bank_china from "../../assets/images/bank/china.png";
import icon_bank_china_commersial from "../../assets/images/bank/china-commersial.png";
import icon_bank_cimb from "../../assets/images/bank/cimb.png";
import icon_bank_cimb_islamic from "../../assets/images/bank/cimbislamic.png";
import icon_bank_citi from "../../assets/images/bank/citi.png";
import icon_bank_duetsche from "../../assets/images/bank/duetsche.png";
import icon_bank_hong_leong from "../../assets/images/bank/hongleong.png";
import icon_bank_hsbc from "../../assets/images/bank/hsbc.png";
import icon_bank_hsbc_amanah from "../../assets/images/bank/hsbcamanah.png";
import icon_bank_islam from "../../assets/images/bank/islam.png";
import icon_bank_kuwait from "../../assets/images/bank/kuwait.png";
import icon_bank_maybank from "../../assets/images/bank/maybank.png";
import icon_bank_maybank_islamic from "../../assets/images/bank/maybankislamic.png";
import icon_bank_mizuho from "../../assets/images/bank/mizuho.png";
import icon_bank_muamalat from "../../assets/images/bank/muamalat.png";
import icon_bank_ocbc from "../../assets/images/bank/ocbc.png";
import icon_bank_paribas from "../../assets/images/bank/paribas.png";
import icon_bank_public from "../../assets/images/bank/public.png";
import icon_bank_rakyat from "../../assets/images/bank/rakyat.png";
import icon_bank_sumitomo from "../../assets/images/bank/sumitomo.png";
import icon_bank_tokyo from "../../assets/images/bank/tokyo.png";
import icon_bank_uob from "../../assets/images/bank/uob.png";
import icon_bank_rhb from "../../assets/images/RHB.svg";

// Dashboard
import icon_dashboard_processing from "../../assets/images/dashboard/process.png";
import icon_dashboard_publishing from "../../assets/images/dashboard/publish.png";
import icon_dashboard_repayment from "../../assets/images/dashboard/amount.png";
import icon_dashboard_month_to_date from "../../assets/images/dashboard/month-to-date.png";
import icon_dashboard_company from "../../assets/images/dashboard/company.png";
import icon_dashboard_total_employee from "../../assets/images/dashboard/total-employee.png";
import icon_dashboard_active_employee from "../../assets/images/dashboard/active-employee.png";
import icon_dashboard_active_applicants from "../../assets/images/dashboard/active-applicants.png";

import icon_check from "../../assets/images/Check-verified.png";
import icon_check_circle_outlined from "../../assets/images/check-circle-outlined.svg";

export const ICON = {
  LOGO: {
    MAIN: bolt_logo,
    SUB: bolt_logo_sub,
    TITLE: icon_logo,
  },
  MENU: {
    icon_dashboard,
    icon_payroll,
    icon_user,
    icon_billing,
    icon_profile,
    icon_logout,
    icon_company,
  },
  LOGIN: {
    icon_logo_login,
  },
  MODAL: {
    icon_update_status,
    icon_modal_billing,
    icon_modal_payroll,
    icon_mark_as_disbursed,
    icon_mark_as_cancel_payroll,
    icon_revert_for_processing_payroll,
    icon_whatsapp,
    icon_warning,
    icon_modal_company_active,
    icon_modal_company_suspended,
    icon_modal_company_terminated,
  },
  COUNTRY: {
    icon_malaysia,
  },
  BANK: {
    icon_bank_affin,
    icon_bank_agro,
    icon_bank_alliance,
    icon_bank_alrajhi,
    icon_bank_ambank,
    icon_bank_america,
    icon_bank_bsn,
    icon_bank_chartered,
    icon_bank_chase,
    icon_bank_china,
    icon_bank_china_commersial,
    icon_bank_cimb,
    icon_bank_cimb_islamic,
    icon_bank_citi,
    icon_bank_duetsche,
    icon_bank_hong_leong,
    icon_bank_hsbc,
    icon_bank_hsbc_amanah,
    icon_bank_islam,
    icon_bank_kuwait,
    icon_bank_maybank,
    icon_bank_maybank_islamic,
    icon_bank_mizuho,
    icon_bank_muamalat,
    icon_bank_ocbc,
    icon_bank_paribas,
    icon_bank_public,
    icon_bank_rakyat,
    icon_bank_sumitomo,
    icon_bank_tokyo,
    icon_bank_uob,
    icon_bank_rhb,
  },
  DASHBOARD: {
    icon_dashboard_processing,
    icon_dashboard_publishing,
    icon_dashboard_repayment,
    icon_dashboard_month_to_date,
    icon_dashboard_company,
    icon_dashboard_total_employee,
    icon_dashboard_active_employee,
    icon_dashboard_active_applicants,
  },
  icon_excel,
  icon_attch_excel,
  icon_pdf,
  icon_add,
  icon_add_white,
  icon_filter,
  icon_comment,
  icon_check,
  icon_check_circle_outlined,
  icon_receipt,
  icon_default_image,
  icon_history,
};

export const BG = {
  LOGIN: {
    bgLogin,
  },
};
